import { SmartenitPlugin } from '../smartenit-plugin';
import { IWebSocketDeviceMessage } from '../../websockets/websocket-device-message.interface';
import { ITextValue } from '../../interfaces/text-value.interface';
import { INumericValue } from '../../interfaces/numeric-value.interface';
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/observable/of';

export class ElectricalMeasurementServerPlugin extends SmartenitPlugin
  implements ITextValue, INumericValue {
  private supportsEnergyUsage: boolean = false;
  public static OPERATION_MODES = [
    { mode: 0, name: 'SINGLE_PHASE_6_CHANNEL' },
    { mode: 1, name: 'SPLIT_PHASE_6_CHANNEL' },
    { mode: 4, name: '3_PHASE_2_CHANNEL_4_WIRE' },
    { mode: 5, name: '3_PHASE_2_CHANNEL_3_WIRE' }
  ];

  public getReportableAttrs() {
    return ['TotalActivePower', 'TotalSummationDelivered', 'ActivePower', 'ActivePowerPhB', 'ActivePowerPhC',
  'SummationDelivered', 'SummationDeliveredPhB', 'SummationDeliveredPhC'];
  }

  public getUnit(attribute?: string): string {
    let response: string = '';

    switch (attribute) {
      case 'ActivePower':
        response = 'kW';
        break;
      case 'SummationDelivered':
        response = 'kWh';
        break;
    }

    return response;
  }

  public getTotalActivePower(): string {
    return this.state.TotalActivePower != null
      ? !isNaN(Number(this.state.TotalActivePower))
        ? Number(this.state.TotalActivePower / 100).toFixed(2)
        : '0'
      : '0';
  }

  public getActivePower(): string {
    return this.state.ActivePower != null && this.state.ACPowerMultiplier != null && this.state.ACPowerDivisor != null
      ? !isNaN(Number(this.state.ActivePower)) && !isNaN(Number(this.state.ACPowerMultiplier)) && !isNaN(Number(this.state.ACPowerDivisor))
        ? ((this.state.ActivePower * (this.state.ACPowerMultiplier / this.state.ACPowerDivisor)) / 1000).toFixed(2)
        : '0'
      : '0';
  }

  public getSummationDelivered(): string {
    return this.state.SummationDelivered != null && this.state.SummationDeliveredMultiplier != null && this.state.SummationDeliveredDivisor != null
      ? !isNaN(Number(this.state.SummationDelivered)) && !isNaN(Number(this.state.SummationDeliveredMultiplier))
        && !isNaN(Number(this.state.SummationDeliveredDivisor))
        ? (((this.state.SummationDelivered * (this.state.SummationDeliveredMultiplier / this.state.SummationDeliveredDivisor)))
          .toFixed(3)).toString()
        : '0'
      : '0';
  }
  public getTotalSummationDelivered(): string {
    return this.getSummationDelivered() != null && this.getSummationDeliveredPhB() != null && this.getSummationDeliveredPhC() != null
      ? !isNaN(Number(this.getSummationDelivered())) && !isNaN(Number(this.getSummationDeliveredPhB()))
        && !isNaN(Number(this.getSummationDeliveredPhC()))
        ? ((Number(this.getSummationDelivered()) + Number(this.getSummationDeliveredPhB()) + Number(this.getSummationDeliveredPhC()))).toFixed(2)
        : '0'
      : '0';
  }

  public getTotalActivePowerPhases(): string {
    return this.getActivePower() != null && this.getActivePowerPhB() != null && this.getActivePowerPhC() != null
      ? !isNaN(Number(this.getActivePower())) && !isNaN(Number(this.getActivePowerPhB()))
        && !isNaN(Number(this.getActivePowerPhC()))
        ? ((Number(this.getActivePower()) + Number(this.getActivePowerPhB()) + Number(this.getActivePowerPhC()))).toFixed(2)
        : '0'
      : '0';
  }

  public getActivePowerPhB(): string {
    return this.state.ActivePowerPhB != null && this.state.ACPowerMultiplier != null && this.state.ACPowerDivisor != null
      ? !isNaN(Number(this.state.ActivePowerPhB)) && !isNaN(Number(this.state.ACPowerMultiplier)) && !isNaN(Number(this.state.ACPowerDivisor))
        ? ((this.state.ActivePowerPhB * (this.state.ACPowerMultiplier / this.state.ACPowerDivisor)) / 1000).toFixed(2)
        : '0'
      : '0';
  }

  public getActivePowerPhC(): string {
    return this.state.ActivePowerPhC != null && this.state.ACPowerMultiplier != null && this.state.ACPowerDivisor != null
      ? !isNaN(Number(this.state.ActivePowerPhC)) && !isNaN(Number(this.state.ACPowerMultiplier)) && !isNaN(Number(this.state.ACPowerDivisor))
        ? ((this.state.ActivePowerPhC * (this.state.ACPowerMultiplier / this.state.ACPowerDivisor)) / 1000).toFixed(2)
        : '0'
      : '0';
  }

  public getSummationDeliveredPhB(): string {
    return this.state.SummationDeliveredPhB != null && this.state.SummationDeliveredMultiplier != null && this.state.SummationDeliveredDivisor != null
      ? !isNaN(Number(this.state.SummationDeliveredPhB)) && !isNaN(Number(this.state.SummationDeliveredMultiplier))
        && !isNaN(Number(this.state.SummationDeliveredDivisor))
        ? (((this.state.SummationDeliveredPhB * (this.state.SummationDeliveredMultiplier / this.state.SummationDeliveredDivisor)))
          .toFixed(3)).toString()
        : '0'
      : '0';
  }

  public getSummationDeliveredPhC(): string {
    return this.state.SummationDeliveredPhC != null && this.state.SummationDeliveredMultiplier != null && this.state.SummationDeliveredDivisor != null
      ? !isNaN(Number(this.state.SummationDeliveredPhC)) && !isNaN(Number(this.state.SummationDeliveredMultiplier))
        && !isNaN(Number(this.state.SummationDeliveredDivisor))
        ? (((this.state.SummationDeliveredPhC * (this.state.SummationDeliveredMultiplier / this.state.SummationDeliveredDivisor)))
          .toFixed(3)).toString()
        : '0'
      : '0';
  }

  public getValue(attribute?: string): number {
    let response: number = 0;

    switch (attribute) {
      case 'TotalActivePower':
        response = this.state.TotalActivePower != null
          ? !isNaN(Number(this.state.TotalActivePower))
            ? (this.state.TotalActivePower).toFixed(3)
            : 0
          : 0;
        break;
      case 'TotalSummationDelivered':
        response = this.getSummationDelivered() != null && this.getSummationDeliveredPhB() != null && this.getSummationDeliveredPhC() != null
          ? !isNaN(Number(this.getSummationDelivered())) && !isNaN(Number(this.getSummationDeliveredPhB()))
            && !isNaN(Number(this.getSummationDeliveredPhC()))
            ? Number(Number(this.getSummationDelivered()).toFixed(3) + Number(this.getSummationDeliveredPhB()).toFixed(3)
              + Number(this.getSummationDeliveredPhC()).toFixed(3))
            : 0
          : 0;
        break;
      case 'ActivePower':
        response = this.state.ActivePower != null && this.state.ACPowerMultiplier != null
          && this.state.ACPowerDivisor != null
          ? !isNaN(Number(this.state.ActivePower)) && !isNaN(Number(this.state.ACPowerMultiplier))
            && !isNaN(Number(this.state.ACPowerDivisor))
            ? Number(((this.state.ActivePower * (this.state.ACPowerMultiplier / this.state.ACPowerDivisor)) / 1000)
              .toFixed(3))
            : 0
          : 0;
        break;
      case 'SummationDelivered':
        response = this.state.SummationDelivered != null && this.state.SummationDeliveredMultiplier != null
          && this.state.SummationDeliveredDivisor != null
          ? !isNaN(Number(this.state.SummationDelivered)) && !isNaN(Number(this.state.SummationDeliveredMultiplier))
            && !isNaN(Number(this.state.SummationDeliveredDivisor))
            ? Number(((this.state.SummationDelivered * (this.state.SummationDeliveredMultiplier / this.state.SummationDeliveredDivisor)))
              .toFixed(3))
            : 0
          : 0;
        break;

      case 'getActivePowerPhB':
        response = this.state.ActivePowerPhB != null && this.state.ACPowerMultiplier != null && this.state.ACPowerDivisor != null
          ? !isNaN(Number(this.state.ActivePowerPhB)) && !isNaN(Number(this.state.ACPowerMultiplier)) && !isNaN(Number(this.state.ACPowerDivisor))
            ? Number(((this.state.ActivePowerPhB * (this.state.ACPowerMultiplier / this.state.ACPowerDivisor)) / 1000).toFixed(2))
            : 0
          : 0;
        break;

      case 'SummationDeliveredPhB':
        response = this.state.SummationDeliveredPhB != null && this.state.SummationDeliveredMultiplier != null
          && this.state.SummationDeliveredDivisor != null
          ? !isNaN(Number(this.state.SummationDeliveredPhB)) && !isNaN(Number(this.state.SummationDeliveredMultiplier))
            && !isNaN(Number(this.state.SummationDeliveredDivisor))
            ? Number(((this.state.SummationDeliveredPhB * (this.state.SummationDeliveredMultiplier / this.state.SummationDeliveredDivisor)))
              .toFixed(3))
            : 0
          : 0;
        break;

      case 'ActivePowerPhC':
        response = this.state.ActivePowerPhC != null && this.state.ACPowerMultiplier != null && this.state.ACPowerDivisor != null
          ? !isNaN(Number(this.state.ActivePowerPhC)) && !isNaN(Number(this.state.ACPowerMultiplier)) && !isNaN(Number(this.state.ACPowerDivisor))
            ? Number(((this.state.ActivePowerPhC * (this.state.ACPowerMultiplier / this.state.ACPowerDivisor)) / 1000).toFixed(2))
            : 0
          : 0;
        break;

      case 'SummationDeliveredPhC':
        response = this.state.SummationDeliveredPhC != null && this.state.SummationDeliveredMultiplier != null
          && this.state.SummationDeliveredDivisor != null
          ? !isNaN(Number(this.state.SummationDeliveredPhC)) && !isNaN(Number(this.state.SummationDeliveredMultiplier))
            && !isNaN(Number(this.state.SummationDeliveredDivisor))
            ? Number(((this.state.SummationDeliveredPhC * (this.state.SummationDeliveredMultiplier / this.state.SummationDeliveredDivisor)))
              .toFixed(3))
            : 0
          : 0;
        break;
    }

    return response;
  }

  public getConditionAttribute(): string {
    //  return this by default but client can choose the attribute from JSON
    return 'ActivePower';
  }

  public getConditionOptions(): any {
    return null;
  }

  public getEffectOptions(): any {
    return null;
  }

  public getEffectAttribute(): string | null {
    return null;
  }

  public getEffectMethod(context?: any): string | null {
    return null;
  }

  public setValue(value: number, attribute?: string, subscribe?: boolean): any {
    //  Do nothing becase values are read only

    if (subscribe) {
      return Observable.of(true);
    }

    return true;
  }

  public getTextValue(context?: string): string {
    if (context && context == 'displayActivePowerOnly') {
      return this.getActivePower() + this.getUnit('ActivePower');
    } else {
      if (this.supportsEnergyUsage) {
        /* Pending check if metrics supported*/
        //  const Summation = `${this.getSummationDelivered()}${'kWh'}`;
        //  const Power = `${this.getActivePower()}${'W'}`;
        //  return `{{CURRENCY}}${this.getPeriodCost()} / ${periodSummation} / ${instDemand}`;
      } else {
        if (context == 'displayPhaseA') {
          return `${this.getActivePower()} kW / ${this.getSummationDelivered()} kWh`;
        }
        if (context == 'displayPhaseB') {
          return `${this.getActivePowerPhB()} kW / ${this.getSummationDeliveredPhB()} kWh`;
        }
        if (context == 'displayPhaseC') {
          return `${this.getActivePowerPhC()} kW / ${this.getSummationDeliveredPhC()} kWh`;
        }
      }
    }
    return '';
  }

  public formatValue(value: string): string {
    return value;
  }

  public getOperationMode(q = '') {
    this.getAttributeWithSubscribeOption(this.componentId, this.processorName, 'MeterConfig', {}, true, q);
  }

  public setOperationMode(mode: number) {
    if (ElectricalMeasurementServerPlugin.OPERATION_MODES.find((op) => op.mode === mode)) {
      return this.setAttributeWithSubscribeOption(this.componentId, this.processorName, 'MeterConfig', { value: mode }, true);
    } else {
      return null;
    }
  }

  /**
   * @param name 16 char string
   * @param channel 3 values only 1, 2, or 3
   */
  public setChannelName(name: string, channel: 1 | 2 | 3) {
    if (!name || name.length > 16) {
      throw new Error('Invalid name, name should be 16 char length');
    }
    if (!channel || channel < 0 || channel > 3) {
      throw new Error('Invalid channel, channel should be either 1, 2 or 3');
    }
    const payload = { value: name };
    const attribute = channel == 1 ? 'Name' : channel == 2 ? 'NamePhB' : 'NamePhC';

    const obs = this.setAttributeWithSubscribeOption(this.componentId, this.processorName, attribute, payload, true, false);
    if (obs) {
      const sub = obs.subscribe((res) => {
        this.state[attribute] = name;
        const da: any = {};
        da[attribute] = name;
        this._onUpdate.next(da);
        sub.unsubscribe();
      });
    }
  }

  public getStatusPayload(): any {
    return [
      //  AC formatting
      //  'ACFrequencyMultiplier',
      //  'ACFrequencyDivisor',
      //  'ACFrequency',
      //  Basic Information
      //  'MeasurementType',
      /* AC (Non-phase Specific) Measurements*/
      'TotalActivePower',
      // 'TotalReactivePower',
      // 'u16ACFrequency',
      'TotalSummationDelivered',
      /* AC Single phase or phase A measurements*/
      'RMSVoltage',
      // 'RMSCurrent',
      'ActivePower',
      // 'ReactivePower',
      // 'PowerFactor',
      'SummationDelivered',
      // 'Name',
      /*  AC Formatting (Single Phase)*/
      // 'ACVoltageMultiplier',
      // 'ACVoltageDivisor',
      // 'ACCurrentMultiplier',
      // 'ACCurrentDivisor',
      'ACPowerMultiplier',
      'ACPowerDivisor',
      'SummationDeliveredMultiplier',
      'SummationDeliveredDivisor',
      /* AC Phase B measurements*/
      'RMSVoltagePhB',
      // 'RMSCurrentPhB',
      'ActivePowerPhB',
      // 'ReactivePowerPhB',
      // 'PowerFactorPhB',
      'SummationDeliveredPhB',
      // 'NamePhB',
      /* AC Phase C measurements*/
      'RMSVoltagePhC',
      // 'RMSCurrentPhC',
      'ActivePowerPhC',
      // 'ReactivePowerPhC',
      // 'PowerFactorPhC',
      'SummationDeliveredPhC',
      // 'NamePhC',
      /* Manufacturer Specific Configuration */
      'CtSelection',
      'MeterConfig',
      // 'RMSVoltageGain',
      // 'RMSVoltageOffset',
      // 'RMSCurrentGain',
      // 'RMSCurrentOffset',
      // 'ActivePowerGain',
      // 'ActivePowerOffset',
      /* Manufacturer Specific Configuration Phase B */
      /*'RMSVoltageGainPhB',
      'RMSVoltageOffsetPhB',
      'RMSCurrentGainPhB',
      'RMSCurrentOffsetPhB',
      'ActivePowerGainPhB',
      'ActivePowerOffsetPhB',*/
      /* Manufacturer Specific Configuration Phase C */
      /*'RMSVoltageGainPhC',
      'RMSVoltageOffsetPhC',
      'RMSCurrentGainPhC',
      'RMSCurrentOffsetPhC',
      'ActivePowerGainPhC',
      'ActivePowerOffsetPhC',*/
    ];
  }

  public processMessage(
    message: IWebSocketDeviceMessage,
    timestamp?: number
  ): any {
    const response = message && message.data && message.data.response;
    const attribute = message && message.attributeOrMethod;

    if (attribute) {
      this.state[attribute] = response.value;
      const payload: any = {};
      payload[attribute] = response.value;
      this._onUpdate.next(payload);
    }

    return this.state;
  }

}
